/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
  DeleteApiV1ExamQuestionLibraryItemIdPathParams,
  DeleteApiV1ExamQuestionLibraryItemId400,
  DeleteApiV1ExamQuestionLibraryItemId401,
  DeleteApiV1ExamQuestionLibraryItemId404,
  DeleteApiV1ExamQuestionLibraryItemId500,
} from "../../types/examQuestionLibraryController/DeleteApiV1ExamQuestionLibraryItemId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1ExamQuestionLibraryItemId } from "../../clients/examQuestionLibraryController/deleteApiV1ExamQuestionLibraryItemId.ts";

export const deleteApiV1ExamQuestionLibraryItemIdMutationKey = () =>
  [{ url: "/api/v1/exam/question-library/item/:id" }] as const;

export type DeleteApiV1ExamQuestionLibraryItemIdMutationKey = ReturnType<
  typeof deleteApiV1ExamQuestionLibraryItemIdMutationKey
>;

export function deleteApiV1ExamQuestionLibraryItemIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1ExamQuestionLibraryItemIdMutationKey();
  return mutationOptions<
    DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamQuestionLibraryItemId400
      | DeleteApiV1ExamQuestionLibraryItemId401
      | DeleteApiV1ExamQuestionLibraryItemId404
      | DeleteApiV1ExamQuestionLibraryItemId500
    >,
    { id: DeleteApiV1ExamQuestionLibraryItemIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1ExamQuestionLibraryItemId(id, config);
    },
  });
}

/**
 * @description Exclui permanentemente uma questão da biblioteca. Caso a questão possua arquivo anexado, ele também é removido do armazenamento. **(Requer Authorization para autenticação)**
 * @summary Excluir questão da biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/item/:id}
 */
export function useDeleteApiV1ExamQuestionLibraryItemId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1ExamQuestionLibraryItemId400
        | DeleteApiV1ExamQuestionLibraryItemId401
        | DeleteApiV1ExamQuestionLibraryItemId404
        | DeleteApiV1ExamQuestionLibraryItemId500
      >,
      { id: DeleteApiV1ExamQuestionLibraryItemIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1ExamQuestionLibraryItemIdMutationKey();

  const baseOptions = deleteApiV1ExamQuestionLibraryItemIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamQuestionLibraryItemId400
      | DeleteApiV1ExamQuestionLibraryItemId401
      | DeleteApiV1ExamQuestionLibraryItemId404
      | DeleteApiV1ExamQuestionLibraryItemId500
    >,
    { id: DeleteApiV1ExamQuestionLibraryItemIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamQuestionLibraryItemId400
      | DeleteApiV1ExamQuestionLibraryItemId401
      | DeleteApiV1ExamQuestionLibraryItemId404
      | DeleteApiV1ExamQuestionLibraryItemId500
    >,
    { id: DeleteApiV1ExamQuestionLibraryItemIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamQuestionLibraryItemId400
      | DeleteApiV1ExamQuestionLibraryItemId401
      | DeleteApiV1ExamQuestionLibraryItemId404
      | DeleteApiV1ExamQuestionLibraryItemId500
    >,
    { id: DeleteApiV1ExamQuestionLibraryItemIdPathParams["id"] },
    TContext
  >;
}
